import { LegalPage, LegalSection } from "@/components/LegalPage";
import { COMPANY } from "@/lib/company";

export default function Terms() {
  return (
    <LegalPage overline="Legal" title="Terms & Conditions" updated="28 June 2026" testid="terms-page">
      <LegalSection>
        <p>
          These Terms &amp; Conditions ("Terms") govern your access to and use of the {COMPANY.brand} website,
          mobile applications and ferry ticket booking services (collectively, the "Platform"), operated by{" "}
          <strong>{COMPANY.legal}</strong> ("we", "us", "our"). By accessing the Platform or making a booking,
          you agree to be bound by these Terms.
        </p>
      </LegalSection>

      <LegalSection heading="1. Eligibility & Accounts">
        <p>You must be at least 18 years of age and capable of entering into a legally binding contract to use the Platform. You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account.</p>
      </LegalSection>

      <LegalSection heading="2. Bookings & Tickets">
        <p>{COMPANY.brand} acts as a booking facilitator between you and the ferry/cruise operators listed on the Platform. A booking is confirmed only after successful payment and issuance of an e-ticket with a valid booking reference. You are responsible for providing accurate passenger details; incorrect details may result in denial of boarding.</p>
      </LegalSection>

      <LegalSection heading="3. Fares, Fees & Payments">
        <p>All fares are displayed in Indian Rupees (INR) and are inclusive of applicable taxes unless stated otherwise. Fares are dynamic and may change until a booking is confirmed. Payments are processed securely through our authorised payment gateway. We do not store your full card or banking details.</p>
      </LegalSection>

      <LegalSection heading="4. Boarding, Identity & Conduct">
        <p>Passengers must carry a valid government-issued photo ID and arrive at the departure jetty within the boarding window specified on the ticket. Operators may deny boarding for late arrival, invalid documents, intoxication, or unsafe conduct. Adherence to operator and maritime safety instructions is mandatory.</p>
      </LegalSection>

      <LegalSection heading="5. Cancellations & Changes">
        <p>Cancellations, refunds and rescheduling are governed by our <a href="/refund" className="text-accent font-medium">Cancellation &amp; Refund Policy</a> and the individual operator's rules. Operators may cancel or reschedule sailings due to weather, tides, technical or regulatory reasons.</p>
      </LegalSection>

      <LegalSection heading="6. Limitation of Liability">
        <p>The Platform is provided on an "as is" basis. To the maximum extent permitted by law, {COMPANY.legal} shall not be liable for any indirect, incidental or consequential loss arising from delays, cancellations, or the acts or omissions of ferry operators. Our aggregate liability for any claim shall not exceed the value of the affected booking.</p>
      </LegalSection>

      <LegalSection heading="7. Intellectual Property">
        <p>All content, trademarks, logos and software on the Platform are owned by or licensed to {COMPANY.legal} and may not be reproduced without prior written consent.</p>
      </LegalSection>

      <LegalSection heading="8. Governing Law & Jurisdiction">
        <p>These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the competent courts at Hyderabad, Telangana.</p>
      </LegalSection>

      <LegalSection heading="9. Contact">
        <p>For questions about these Terms, write to us at <a href={`mailto:${COMPANY.email}`} className="text-accent font-medium">{COMPANY.email}</a> or visit our <a href="/contact" className="text-accent font-medium">Contact Us</a> page.</p>
      </LegalSection>
    </LegalPage>
  );
}
